<template>
  <div class="under-development-wrap">
    <div class="development-card">
      <img src="@/assets/icons/construction.png" alt="建设中" class="construction-img" />
      <h2 class="dev-title">持续上线中</h2>
      <p class="dev-desc">该模块正在紧张开发与打磨中，敬请期待~</p>
      <!-- <div class="dev-actions">
        <a-button type="primary" @click="goBack">
          <RollbackOutlined />
          返回上一页
        </a-button>
        <a-button class="btn-home" @click="goHome">
          <HomeOutlined />
          返回首页
        </a-button>
      </div> -->
    </div>
  </div>
</template>

<script setup>
// import { useRouter } from 'vue-router'
// import { RollbackOutlined, HomeOutlined } from '@ant-design/icons-vue'

// const router = useRouter()

// const goBack = () => {
//   router.go(-1)
// }

// const goHome = () => {
//   router.push('/home')
// }
</script>

<style scoped lang="less">
.under-development-wrap {
  width: 100%;
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  box-sizing: border-box;
  background: #f7f9fc;
}

.development-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 64px 48px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  max-width: 520px;
  width: 100%;
}

.construction-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  margin-bottom: 32px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.dev-title {
  font-size: 24px;
  font-weight: 600;
  color: #142649;
  margin: 0 0 12px;
}

.dev-desc {
  font-size: 14px;
  color: #62728B;
  margin: 0 0 40px;
  line-height: 22px;
}

.dev-actions {
  display: flex;
  justify-content: center;
  gap: 16px;

  .btn-home {
    color: #1677ff;
    border-color: #1677ff;
    background: #ffffff;

    &:hover {
      color: #4096ff;
      border-color: #4096ff;
    }
  }
}
</style>